import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { G_VehicleStatusViewModel } from 'src/app/viewmodels/g-settings/G_VehicleStatusViewModel';
import { SaveVehicleStatusRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-vehicle-status',
  templateUrl: './vehicle-status.component.html',
  styleUrls: ['./vehicle-status.component.scss']
})
export class VehicleStatusComponent implements OnInit {

  modalRef: BsModalRef;
  public itemVm: SaveVehicleStatusRequest;
  public brands: any = [];
  public deleteId: string;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
  }

  ngAfterViewInit() {
  }

  getList() {
    this.spinner.show();
    this._uow.gSettingService.GetVehicleStatusesAsync().subscribe((res: any) => {
      this.brands = res.result;
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveVehicleStatusRequest();
    }
  }

  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.gSettingService.DeleteVehicleStatusAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
      this.spinner.hide();
    }, (err) => {
      this.spinner.hide();
    });
  }

  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.modalRef.hide();
      this.itemVm = new SaveVehicleStatusRequest();
      this.getList();
    }
  }
}
